import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

function PageNotFound() {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="We couldn't find your page"
      subTitle={
        <pre>
          "But you could visit any one of our other (non-imaginary) pages"
        </pre>
      }
      extra={
        <Button type="primary" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      }
    />
  );
}

export default PageNotFound;
